module.exports = __webpack_public_path__ + "79dadc6c6c8562c7c2271aeed850c528.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4.jpg
// module id = 221
// module chunks = 0